/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Schema_Faq_A2Inputs */

const en_guide_json_schema_faq_a2 = /** @type {(inputs: Guide_Json_Schema_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular validators include Ajv (JavaScript), jsonschema (Python), and everit-org/json-schema (Java). Most web frameworks have built-in or plugin-based JSON Schema validation support.`)
};

const ko_guide_json_schema_faq_a2 = /** @type {(inputs: Guide_Json_Schema_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인기 있는 유효성 검사기로는 Ajv (JavaScript), jsonschema (Python), everit-org/json-schema (Java)가 있습니다. 대부분의 웹 프레임워크에는 내장 또는 플러그인 기반의 JSON Schema 유효성 검사 지원이 있습니다.`)
};

const ja_guide_json_schema_faq_a2 = /** @type {(inputs: Guide_Json_Schema_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`人気のバリデータにはAjv（JavaScript）、jsonschema（Python）、everit-org/json-schema（Java）があります。ほとんどのWebフレームワークには、組み込みまたはプラグインベースのJSON Schemaバリデーションサポートがあります。`)
};

/**
* | output |
* | --- |
* | "Popular validators include Ajv (JavaScript), jsonschema (Python), and everit-org/json-schema (Java). Most web frameworks have built-in or plugin-based JSON S..." |
*
* @param {Guide_Json_Schema_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_schema_faq_a2 = /** @type {((inputs?: Guide_Json_Schema_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Schema_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_schema_faq_a2(inputs)
	if (locale === "ko") return ko_guide_json_schema_faq_a2(inputs)
	return ja_guide_json_schema_faq_a2(inputs)
});